export default [
	{
		id: "stats",
		name: "resources.bookmaker-imports.fields.types.stats",
	},
	{
		id: "customers",
		name: "resources.bookmaker-imports.fields.types.customers",
	},
	{
		id: "dynamic_variables",
		name: "resources.bookmaker-imports.fields.types.dynamic_variables",
	},
];
